import './images/tenders-header-bg.jpg';
import './styles/tenders';

import $ from 'jquery'
import Barba from 'barba.js';

const $button = $('[data-load]');

import { isFirst } from './common'

function tenderOn() {
  $(function () {
      /**
       * Ajax more button
       */

      let isAjaxSending = false;
      let $wrapper = $('[data-tenders-container]');

      $button.on('click', function () {
          if (isAjaxSending) return 1;
          let $lastChild = $wrapper.find('[data-item]:last');
          let dataCount = $lastChild.data('count');
          let showValue = 5;

          $.ajax({
              method: 'POST',
              url: '/include/tenders_ajax.php',
              data: {
                  requested: showValue,
                  current: dataCount
              },
              complete: function (jqXHR) {
                  $wrapper.append(jqXHR.responseText);
                  let currentCount = $wrapper.find('[data-item]:last').attr('data-count');
                  let totalCount = $wrapper.find('[data-item]:last').attr('data-count-total');
                  if (totalCount ===  currentCount) $button.hide();
              }
          });
      });

      /**
       * Search by name
       */

      // let $searchByNameForm = $('[data-search]');


      if ($('.subscribe__actions').children().length) {
        $('.subscribe').addClass('show-actions');
        $('html, body').animate({ scrollTop: $('.subscribe').offset().top }, 500);
      }


      $('.tenders-content').on('click', '.tender__btn', function () {
          let $self = $(this);
          let $tender = $self.parent().parent();
          const ACTIVE = 'is-active';

          if ($tender.hasClass(ACTIVE)) {
              $tender.removeClass(ACTIVE);
          } else {
              $tender.addClass(ACTIVE);
          }
      });

      $('.subscribe__email').on('blur input', function () {
          let $self = $(this);
          let $validtext = $('.subscribe__valid');
          let $btn = $('.subscribe__btn');
          let $container = $('.subscribe');

          if ($self.val() !== '') {
              let pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
              if (pattern.test($self.val())) {
                  $self.css({'border-color': 'green'});
                  $validtext.text('');
                  
                  if($('#personal-data').prop('checked')) {
                    $btn.prop('disabled', false);
                  } 
                //   $btn.prop('disabled', false);
                  $btn.on('click', function (e) {
                      e.preventDefault();
                      $container.attr('data-side', '2');
                      $btn.text('Подписаться');
                      $btn.prop('type', 'submit');
                  });
              } else {
                  $btn.prop('disabled', true);
                  $self.css({'border-color': 'red'});
                  $validtext.text('Поле e-mail заполнено не верно')
              }
          } else {
              $btn.prop('disabled', true);
              $self.css({'border-color': 'red'});
              $validtext.text('Поле e-mail должно быть заполнено');
          }
      });

      $('.subscribe__btn').on('click', function () {
          let $form = $('.subscribe__form');
          if ($(this).prop('type') === 'submit') {
              $form.submit();
          }
      });

 

      $('#personal-data').on('change', function() {
        const $elm = $(this)
        const isChecked = $elm.prop('checked')
        const pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
        const $btn = $('.subscribe__btn');
        const $email = $('.subscribe__email')
       

        if(isChecked) {
            if (pattern.test($email.val())) {
                $btn.prop('disabled', false);
            }
        } else {
            $btn.prop('disabled', true);
        }
      })
        


  });
}

!isFirst || tenderOn();

const Tenders = Barba.BaseView.extend({
    namespace: 'tenders',

    onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
        tenderOn();
    },

    onEnterCompleted() {
        //console.log('Переход закончился.')
    },

    onLeave() {
        //console.log('Новый переход к новой странице только начался.')
    },

    onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    },
});

Tenders.init();



// WEBPACK FOOTER //
// ./tenders.js